const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Resolves stored image URLs. Relative "/api/files/..." paths are prefixed with
// the current backend URL so images work on any deployed domain.
export const resolveImageUrl = (url) => {
  if (!url) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  return url;
};
